<template>
  <div>
    <a-card :bordered="false">
      <div style="display: flex; flex-wrap: wrap;">
        <head-info
          title="云码剩余数量"
          :content="code_type==='FOREVER'? '可无限使用' : code_balance"
          :showBtn="code_type!=='FOREVER'"
          btn-text="充值"
          @tapbtn="handleRecharge"
        />
        <head-info
          title="云码已打印数量"
          :content="code_print_sum"
        />
        <head-info
          title="云码已被查询数量"
          :content="code_query_sum"
        />
        <head-info
          title="总浏览量"
          :content="read_sum"
        />
        <head-info
          title="账户余额"
          :content="balance"
        >
          <a-button
            type="link"
            @click="handleWithdraw"
          >申请提现</a-button>
          <a-button
            type="link"
            @click="handleWithdrawRecord"
          >提现记录</a-button>
        </head-info>
      </div>
    </a-card>
    <a-row :gutter="20">
      <a-col :md="24" :lg="24" :xl="24" :xxl="12" >
        <a-card
          :bordered="false"
          class="mt-20"
          title="页面列表"
        >
          <a-button
            slot="extra"
            type="primary"
            class="mr-20"
            @click="addCustomPage"
          >新增页面</a-button>
          <a-button
            slot="extra"
            type="primary"
            class="mr-20"
            @click="exportCustomPage"
          >导出</a-button>
          <!-- 表格筛选 start -->
          <a-form layout="inline">
            <a-form-item class="mr-20">
              <a-input
                v-model="queryParam.keyWord"
                placeholder="页面名称"
                allowClear
              />
            </a-form-item>
            <a-form-item>
              <a-button
                class="mr-10"
                type="primary"
                @click="handlePagesFilter"
              >
                搜索
              </a-button>
              <a-button @click="handlePagesReset">
                重置
              </a-button>
            </a-form-item>
          </a-form>
          <!-- 表格筛选 end -->
          <!-- 表格 start -->
          <tcg-table
            ref="pagesTable"
            size="default"
            :columns="columns"
            :data="loadData"
            bordered
            class="mt-20"
          >
            <span
              slot="action"
              slot-scope="text, record"
            >
              <a-button type="link" @click="handleLook(record.page_id, 'PAGE', record.title, record.brand_id, record.is_index)">查看</a-button>
              <a-button v-if="record.page_type==='NORMAL' || record.page_type==='PRODUCT' || record.page_type==='CONTACT'" type="link" @click="handleEditPage(record.page_id)">编辑</a-button>
              <a-button v-if="record.page_type==='NORMAL' || record.page_type==='PRODUCT' || record.page_type==='CONTACT'" type="link" @click="copyPage(record.page_id)">复制</a-button>
              <a-button v-if="(record.page_type==='NORMAL' || record.page_type==='PRODUCT' || record.page_type==='CONTACT') && record.is_index==='NO' " type="link" @click="handleDelectPage(record.page_id)">删除</a-button>
              <a-button type="link" @click="handlePrint(record.page_id, 'PAGE', record.title, record.brand_id, record.is_index)">打印云码</a-button>
            </span>
          </tcg-table>
          <!-- 表格 end -->
        </a-card>
      </a-col>
      <a-col :md="24" :lg="24" :xl="24" :xxl="12">
        <a-card
          :bordered="false"
          class="mt-20"
          title="商品列表"
        >
          <a-button
            slot="extra"
            type="primary"
            class="mr-20"
            @click="handleAddGoods"
          >新增商品</a-button>
          <a-button
            slot="extra"
            type="primary"
            class="mr-20"
            @click="exportGoods"
          >导出</a-button>
          <!-- 表格筛选 start -->
          <a-form layout="inline">
            <a-form-item class="mr-20">
              <a-input
                v-model="queryParam2.keyWord"
                placeholder="商品名称"
                allowClear
              />
            </a-form-item>
            <a-form-item>
              <a-button
                class="mr-10"
                type="primary"
                @click="handleGoodsFilter"
              >
                搜索
              </a-button>
              <a-button @click="handleGoodsReset">
                重置
              </a-button>
            </a-form-item>
          </a-form>
          <!-- 表格筛选 end -->
          <!-- 表格 start -->
          <tcg-table
            ref="goodsTable"
            size="default"
            :columns="columns2"
            :data="loadData2"
            bordered
            class="mt-20"
          >
            <span
              slot="action"
              slot-scope="text, record"
            >
              <a-button type="link" @click="handleLook(record.goods_id, 'GOODS', record.name, record.brand_id)">查看</a-button>
              <a-button type="link" @click="handleEditGoods(record.goods_id)">编辑</a-button>
              <a-button type="link" @click="copyGoods(record.goods_id)">复制</a-button>
              <a-button type="link" @click="handleDeleteGoods(record.goods_id)">删除</a-button>
              <a-button type="link" @click="handlePrint(record.goods_id, 'GOODS', record.name, record.brand_id)">打印云码</a-button>
            </span>
          </tcg-table>
          <!-- 表格 end -->
        </a-card>
      </a-col>
    </a-row>
    <!-- 支付面板弹框 -->
    <pay-panel
      ref="payPanel"
      :price="curItem.total_price"
      :orderType="curItem.order_type"
      :defaultPayType="curItem.pay_type"
      @close="getIndexStatistics"
    />
    <!-- 创建订单弹框 -->
    <property-order-modal ref="PropertyOrderModal" @ok="handlePay" />
    <!-- 申请提现 -->
    <withdraw-modal ref="WithdrawModal" @success="getIndexStatistics(false)" />
    <!-- 提现记录 -->
    <withdraw-list-modal ref="WithdrawListModal" />
  </div>
</template>

<script>
import WithdrawListModal from '@/components/WithdrawListModal'
import WithdrawModal from '@/components/WithdrawModal'
import PropertyOrderModal from '@/components/PropertyOrderModal'
import PayPanel from '@/components/PayPanel'
import HeadInfo from '@/components/tools/HeadInfo'
import { TcgTable } from '@/components'
import { getIndexStatistics, getPagesList, postPagessDel, postCopyPage } from '@/api/pages'
import { getGoodsList, postGoodsDel, postCopyGoods } from '@/api/goods'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  searchType: 'title'
}
const defaultQueryParam2 = {
  searchType: 'name'
}

export default {
  name: 'Dashboard',
  components: { HeadInfo, TcgTable, PropertyOrderModal, PayPanel, WithdrawModal, WithdrawListModal },
  data() {
    return {
      code_type: 'NORMAL', // NORMAL、FOREVER
      code_balance: 0,
      code_print_sum: 0,
      code_query_sum: 0,
      read_sum: 0,
      balance: 0,
      queryParam: Object.assign({}, defaultQueryParam),
      queryParam2: Object.assign({}, defaultQueryParam2),
      // 页面列表
      columns: [
        {
          title: '页面ID',
          dataIndex: 'page_id',
          width: '80px'
        },
        {
          title: '页面名称',
          dataIndex: 'title',
          width: '120px'
        },
        {
          title: '云码数量',
          dataIndex: 'security_code_count'
        },
        {
          title: '已被查询云码',
          dataIndex: 'query_code_count'
        },
        {
          title: '查询总次数',
          dataIndex: 'query_total_count'
        },
        {
          title: '当月浏览量',
          dataIndex: 'now_month_visits'
        },
        {
          title: '浏览量',
          dataIndex: 'read_count'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          width: '180px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 商品列表
      columns2: [
        {
          title: '商品ID',
          dataIndex: 'goods_id',
          width: '80px'
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          width: '120px'
        },
        {
          title: '云码数量',
          dataIndex: 'security_code_count'
        },
        {
          title: '已被查询云码',
          dataIndex: 'query_code_count'
        },
        {
          title: '查询总次数',
          dataIndex: 'query_total_count'
        },
        {
          title: '当月浏览量',
          dataIndex: 'now_month_visits'
        },
        {
          title: '浏览量',
          dataIndex: 'read_count'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          width: '180px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getPagesList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      },
      // 商品加载数据方法 必须为 Promise 对象
      loadData2: (parameter) => {
        return getGoodsList(Object.assign(parameter, this.queryParam2)).then((res) => {
          return res
        })
      },
      curItem: {
        // {
        //   total_price: total_price,
        //   order_type: order_type,
        //   orderId: orderId
        // }
      }
    }
  },
  created() {
    this.getIndexStatistics()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.name === 'customPageEdit' || from.name === 'customPageAdd') {
        vm.$refs.pagesTable.refresh(true)
      }
      if (from.name === 'goodsEdit' || from.name === 'goodsAdd') {
        vm.$refs.goodsTable.refresh(true)
      }
    })
  },
  methods: {
    // 获取首页统计
    getIndexStatistics(noShowTip = true) {
      getIndexStatistics()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.code_type = data.code_type
            this.code_balance = data.code_balance
            this.code_print_sum = data.code_print_sum
            this.code_query_sum = data.code_query_sum
            this.read_sum = data.read_sum
            this.balance = data.balance
            if (noShowTip && data.expire_notice) {
              this.accountExpiredTip(data.expire_notice)
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求首页统计失败')
        })
    },
    /**
     * 账号即将到期提醒
     */
    accountExpiredTip(notice) {
      this.$warning({
        title: '账号即将到期提醒',
        // content: '您好，您的账号到期时间为：2021-12-12，请您在到期之前进行续费，否则您的系统及云码页面将无法访问'
        content: notice
      })
    },
    handlePagesFilter() {
      this.$refs.pagesTable.refresh(true)
    },
    handlePagesReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.pagesTable.refresh(true)
    },
    handleGoodsFilter() {
      this.$refs.goodsTable.refresh(true)
    },
    handleGoodsReset() {
      this.queryParam2 = Object.assign({}, defaultQueryParam2)
      this.$refs.goodsTable.refresh(true)
    },
    // 查看
    handleLook(relation_id, relation_type, relation_name, brand_id = 1, is_index = 'NO') {
      this.$router.push({ name: 'securityCodeDetail', query: { relation_id, relation_type, relation_name, brand_id, is_index } })
    },
    // 页面编辑
    handleEditPage(id) {
      this.$router.push({ name: 'customPageEdit', query: { id } })
    },
    // 商品编辑
    handleEditGoods(id) {
      this.$router.push({ name: 'goodsEdit', query: { id } })
    },
    // 页面复制
    copyPage(id) {
      postCopyPage({ id }).then((res) => {
        if (res.code === 200) {
          this.$refs.pagesTable.refresh(true)
          this.$message.success(res.message)
        }
      }).catch((e) => {
        this.$message.error('复制失败')
      })
    },
    // 商品复制
    copyGoods(id) {
      postCopyGoods({ id }).then((res) => {
        if (res.code === 200) {
          this.$refs.goodsTable.refresh(true)
          this.$message.success(res.message)
        }
      }).catch((e) => {
        this.$message.error('复制失败')
      })
    },
    // 删除页面
    handleDelectPage(id) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          postPagessDel({
            page_id: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.$refs.pagesTable.refresh(true)
              }
            })
            .catch((e) => {
              this.$message.error('删除失败')
            })
        }
      })
    },
    // 删除商品
    handleDeleteGoods(id) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          postGoodsDel({
            goods_id: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.$refs.goodsTable.refresh(true)
              }
            })
            .catch((e) => {
              this.$message.error('删除失败')
            })
        }
      })
    },
    // 打印云码
    handlePrint(relation_id, relation_type, relation_name, brand_id = 1, is_index = 'NO') {
      this.$router.push({ name: 'printCode', query: { relation_id, relation_type, relation_name, brand_id, is_index } })
    },
    /**
     * 新增页面
     */
    addCustomPage() {
      this.$router.push({ name: 'customPageAdd' })
    },
    /**
     * 新增商品printCode
     */
    handleAddGoods() {
      this.$router.push({ name: 'goodsAdd' })
    },
    /**
     * 导出页面
     */
    exportCustomPage () {
      // window.location.href = window.location.origin + '/merchant.php/Page/outExcel'
      const href = window.location.origin + '/merchant.php/Page/outExcel'
      downloadFile(href)
    },
    /**
     * 导出商品
     */
    exportGoods () {
      // window.location.href = window.location.origin + '/merchant.php/Goods/outExcel'
      const href = window.location.origin + '/merchant.php/Goods/outExcel'
      downloadFile(href)
    },
    // 充值
    handleRecharge() {
      this.$refs.PropertyOrderModal.showModal('RECHARGE')
    },
    // 支付
    handlePay(item) {
      // {
      //   total_price: total_price,
      //   order_type: order_type,
      //   orderId: orderId
      // }
      this.curItem = Object.assign({}, item)
      this.$refs.payPanel.showModal(item.orderId)
    },
    // 申请提现
    handleWithdraw() {
      this.$refs.WithdrawModal.showModal()
    },
    // 提现记录
    handleWithdrawRecord() {
      this.$refs.WithdrawListModal.showModal()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
